// Pages Router only
export { default } from '../pages/_error'
export * from '../pages/_error'

export { unstable_catchError } from '../client/components/catch-error'
export type { ErrorInfo } from '../client/components/error-boundary'
